<template>
  <SfModal v-if="modalOpen" size="xs" :scrollable-content="true" @close="close">
    <template #title>
      <span v-dompurify-html="modalTitle" />
    </template>

    <template #body>
      <MoveList
        :title="title"
        :copy="isExportRelated"
        :query-params="queryParams"
        :post-params="postParams"
        :permanent-entries="permanentEntries"
        :permanent-category="permanentCategory"
        @navigate="navigateTo"
        @move="moveTo"
      />
    </template>

    <template #footer>
      <button class="sf-btn" @click="close">
        {{ I18n.t('confirmation.cancel') }}
      </button>
    </template>
  </SfModal>
</template>

<script>
import { SfModal } from '@app/shared/vue/components/sf-modal'
import MoveList from './move-list'

import api from '../api/index'

export default {
  components: {
    SfModal,
    MoveList,
  },
  data() {
    return {
      modalOpen: false,
      batchMove: false,
      title: '',
      id: null,
      type: null,
      selectedEntryIds: [],
      exportIds: [],
      permanentCategory: null,
      permanentEntries: [],
    }
  },
  computed: {
    isExportRelated() {
      return this.type === 'export' || this.exportIds?.length
    },
    modalTitle() {
      if (this.isExportRelated) {
        return I18n.t('permanent.move_list.copy', { title: this.title })
      }
      if (this.batchMove) {
        return I18n.t('permanent.move_list.batch_move_title')
      }
      return I18n.t('permanent.move_list.move', { title: this.title })
    },
    moveUrl() {
      if (this.batchMove) {
        if (this.exportIds?.length) {
          return Silverfin.Routes.batch_move_exports_permanent_entries_path({
            firm_id: Silverfin.currentFirmId,
            company_id: Silverfin.currentCompanyId,
            _options: true,
          })
        }
        return Silverfin.Routes.batch_move_permanent_entries_path({
          firm_id: Silverfin.currentFirmId,
          company_id: Silverfin.currentCompanyId,
          _options: true,
        })
      }
      return Silverfin.Routes.move_permanent_entries_path({
        firm_id: Silverfin.currentFirmId,
        company_id: Silverfin.currentCompanyId,
        _options: true,
      })
    },
    queryParams() {
      if (this.batchMove) {
        if (this.exportIds?.length) {
          return { export_ids: this.exportIds }
        }
        return { selected_entries: this.selectedEntryIds.join(',') }
      }
      return { type: this.type, id: this.id }
    },
    postParams() {
      if (this.batchMove) {
        if (this.exportIds?.length) {
          return { export_ids: this.exportIds }
        }
        return { selected_entries: this.selectedEntryIds }
      }
      return { type: this.type, id: this.id }
    },
  },
  methods: {
    close() {
      this.modalOpen = false
    },
    setData(params) {
      this.batchMove = params.batchMove
      this.title = params.title
      this.id = params.id
      this.type = params.type
      this.selectedEntryIds = params.selectedEntryIds
      this.exportIds = params.exportIds
      this.permanentCategory = params.permanentCategory
      this.permanentEntries = params.permanentEntries
    },
    openModal(params) {
      this.setData(params)
      this.modalOpen = true
    },
    navigateTo(params) {
      api
        .navigateTo(this.navigateUrl(params))
        .then((response) => this.setData(response))
    },
    moveTo(payload) {
      api.moveTo(this.moveUrl, payload)
    },
    navigateUrl(params) {
      if (this.batchMove) {
        if (this.exportIds?.length) {
          return Silverfin.Routes.batch_move_exports_modal_permanent_entries_path(
            {
              firm_id: Silverfin.currentFirmId,
              company_id: Silverfin.currentCompanyId,
              ...params,
              _options: true,
            }
          )
        }
        return Silverfin.Routes.batch_move_modal_permanent_entries_path({
          firm_id: Silverfin.currentFirmId,
          company_id: Silverfin.currentCompanyId,
          ...params,
          _options: true,
        })
      }
      return Silverfin.Routes.move_modal_permanent_entries_path({
        firm_id: Silverfin.currentFirmId,
        company_id: Silverfin.currentCompanyId,
        ...params,
        _options: true,
      })
    },
  },
}
</script>
